import React, {
	useEffect,
	useState,
	useRef,
	createContext,
	useLayoutEffect,
} from 'react';
import Input from '../../../FlyfishComponents/Input';
import styled from 'styled-components';
import EcomChats from './EcomChats';
import TimeUtil from '../../../../Utils/TimeUtil';
import { saveStateSession } from '../../../FlyfishComponents/flyfishutils/utils';
import {
	loadStateSession,
	capitalizeFirstLetter,
	getCurrencySymbol,
	NumberFormattinginLocale,
} from '../../../FlyfishComponents/flyfishutils/utils';
import SFModal from '../../../BaseComponents/SFModal';
import MessageFeedbackComment from '../../MessageFeedback/MessageFeedbackComment';
import { UploadImage, MicIcon } from '../../Buttons/IconButton/Icons';
import EcomFilter from './EcomChats/EcomFilter';
import Lottie from 'react-lottie';
import VoiceModal from './VoiceModal';
import InteractiveButton from '../../../FlyfishComponents/Button/InteractiveButton';
import AutoComplete from '../../../FlyfishComponents/AutoComplete';
import { CloseInput } from '../../../FlyfishComponents/flyfishIcons/icons';
import UploadImageDesktop from './UploadImageDesktop';
import useScreenSize from '../../../Hooks/DeviceScreenSize/';
import UploadImageMobile from './UploadImageMobile';
import StylistLogo from '../../../../../assets/imgs/FF_Stylist_logo.png';
import Logo from '../../../../../assets/imgs/logo.png';
import useScreenType from '../../../Hooks/DeviceType';
import ModelImage from '../../../../../assets/imgs/hero-image-container.png';
import ModelMobileImage from '../../../../../assets/imgs/hero-image.png';
import Card1 from '../../../../../assets/imgs/Card1.png';
import Card2 from '../../../../../assets/imgs/Card2.png';
import Card3 from '../../../../../assets/imgs/Card3.png';

import { EcomSearcContainer, SortFilterContainer } from './ecomsearch.styled';
import { Carousel } from 'react-responsive-carousel';
import useOutsideClick from '../../../Hooks/OutsideClick';
import Slider from '@mui/material/Slider';
import EcomFilterMobile from './EcomChats/EcomFilterMobile';
import Axios from 'axios';
import { SortTick } from '../../../FlyfishComponents/flyfishIcons/icons';
import ProductLoader from './ProductLoader';
import { getImg } from '../../../../Utils/getImg';

const SliderContainer = styled.div`
	padding-left: 18px;
	.MuiSlider-root {
		width: 90%;
	}
	.MuiSlider-thumb {
		color: var(--secondary-color-ff-secondary400);
		background-color: #fff;
		border: 6px solid var(--secondary-color-ff-secondary400);
		box-shadow: none !important;
	}
	.MuiSlider-track {
		height: 8px;
		color: var(--secondary-color-ff-secondary400);
	}
	.MuiSlider-rail {
		height: 8px;
		background-color: #d9d9d9;
	}
	.price-slider-container {
		width: 300px;
		margin: 20px;
	}

	.slider-values {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.slider {
		height: 8px;
		background: #d9d9d9; /* Full track background */
		border-radius: 5px;
		position: relative;
		flex-grow: 1;
	}

	.slider-track {
		background: rgba(248, 49, 188, 0.3); /* Highlight only between thumbs */
		height: 8px;
		border-radius: 5px;
	}

	.slider-thumb {
		height: 20px;
		width: 20px;
		background-color: var(--secondary-color-ff-secondary400);
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		top: -6px;
	}

	.slider-labels {
		display: flex;
		justify-content: space-between;
		font-size: 0.9rem;
		margin-top: 0px;
		color: var(--black-60);
		margin-left: 0px;
		margin-right: 12px;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 21px;
	}
`;
const EcomInput = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	@media screen and (max-width: 800px) {
		grid-template-columns: 20px 1fr 20px;
	}
	padding: 12px 28px;
	align-items: center;
	grid-gap: 12px;
	&.adjust-header {
		padding: 12px 28px 16px 28px;
	}
	&.adjust-mobile-header {
		grid-template-columns: 0px 1fr 0px !important;
	}
	& > img {
		max-width: 200px;
		max-height: 45px;
	}

	.ff-ecom-input {
		.ff-input {
			min-width: 656px; /*772px*/
			max-width: initial;

			.MuiInputBase-root {
				padding: 6px 12px;
				border-radius: 25px;
				height: 36px;
				&:not(.Mui-disabled, .Mui-error):hover {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--primary-color-ff-primary500);
					}
				}

				&:not(.Mui-disabled, .Mui-error).Mui-focused {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--primary-color-ff-primary500);
					}
				}

				input {
					font-family: var(--fontFamily);
				}
			}
		}
	}
	.ff-sort-by {
		display: none;
		input {
			cursor: pointer;
		}
		&.desktop {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-right: 0px; /*22px*/
			min-width: 320px;
		}
		.ff-ecom-search-input {
			.MuiFormControl-root {
				min-width: 230px;
				&:hover {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--primary-color-ff-primary500);
					}
				}

				&.Mui-focused {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--primary-color-ff-primary500) !important;
					}
				}
			}
		}
	}

	&.showImage {
		.ff-ecom-input {
			.ff-input {
				.MuiInputBase-root {
					height: 56px !important;
				}
			}
		}
	}

	&.tablet {
		.ff-ecom-input {
			@media screen and (max-width: 1024px) {
				.ff-input {
					min-width: 588px;
					max-width: unset;
				}
			}
			@media screen and (min-width: 500px) {
				.ff-input {
					min-width: unset;
					max-width: unset;
				}
			}
		}
	}
	&.mobile {
		grid-template-columns: 18px 1fr 24px;
		padding: 12px;
		.ff-ecom-input {
			.ff-input {
				min-width: unset;
				max-width: unset;
			}
		}
	}
`;
export const LoaderWrapper = styled.div`
	background-color: #fff;
	aspect-ratio: ${(props) =>
		loadStateSession('productCardAspectRatio')
			? `${loadStateSession('productCardAspectRatio')}`
			: 'unset'};
	border-radius: 8px;
	border: 1px solid rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	flex-grow: 0;
	justify-content: center;
	align-items: center;
	box-shadow: none !important;
	max-height: 400px;
	width: 295px;

	.ff-lottie-container {
		width: 80%;
		aspect-ratio: 1;
		border-radius: 100%;
		background-color: unset !important;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.5s ease;
		position: relative;
		z-index: 0;
		@media screen and (max-width: 600px) {
			width: calc(50% - 6px);
		}
	}
	.ff-lottie {
		width: 70%;
		position: relative;
	}
	.ff-fashion-tip {
		margin: 0px 16px;
		line-height: 1.4;
		text-align: center;
		min-height: 56px;
		color: var(--ffNeutral500);
		font-weight: 100;
	}
`;

export const LoaderWrapperParent = styled.div`
	display: flex;
	padding-top: 24px;
	width: calc(100%);
	gap: 12px;
	height: 100vh;
	background-color: #faf8fc;
	flex-direction: column;
	align-items: center;
	@media screen and (max-width: 600px) {
		grid-template-columns: 1fr 1fr;
	}
	.ff-fashion-tip {
		color: var(--neutral-color-ff-neutral600);
		font-size: 20px;
		line-height: 28px;
		padding: 12px 24px;
		letter-spacing: 0.6px;
	}
	&.mobile,
	&.tablet {
		overflow: auto;
		height: calc(100vh - 100px);
		& > div:not(.ff-fashion-tip) {
			display: grid !important;
			grid-template-columns: 1fr 1fr;
			gap: 12px !important;
			padding: 0 12px;
			& .ff-fashion-tip {
				grid-column: span 2;
				text-align: center;
				padding: 24px;
			}
			& > .ff-loader-card {
				width: auto;
				aspect-ratio: ${(props) =>
					loadStateSession('productCardAspectRatio')
						? `${loadStateSession('productCardAspectRatio')}`
						: 'unset'};
			}
		}
	}
`;

const EcomContainer = styled.div`
	.ff-autocomplete {
		& .MuiAutocomplete-popper {
			& .MuiAutocomplete-option {
				color: #1c0047;
				display: flex;
				justify-content: space-between;
				padding: 4px 12px !important;
				&[aria-selected='true'] {
					background-color: rgba(246, 242, 251, 1) !important;
				}
			}
			.MuiAutocomplete-noOptions {
				color: #1c0047;
			}
		}
		& .MuiInputBase-root {
			padding: 6px 12px !important;
			> input {
				color: var(--color-scale-1, #1c0047);
				font-size: 14px;
				font-weight: 400;
				letter-spacing: 0.42px;
			}
		}
	}

	position: relative;
	font-family: var(--fontFamily);
	.ff-side-filter-content {
		display: grid;
		grid-template-columns: 240px auto;
		.showCart .ff-ecom-chats {
			overflow-y: auto;
		}
		&.mobile,
		&.tablet {
			justify-content: center;
			grid-template-columns: none;
		}
		&.ff-cart-page {
			grid-template-columns: auto auto;
		}

		&.showCart {
			grid-template-columns: none;
		}
	}
	.side-filter {
		&.adjust-filter {
			margin-top: -48px;
			border-right: 1px solid var(--black-10, rgba(0, 0, 0, 0.1));
		}
		&.mobile,
		&.tablet {
			width: unset;
			display: none;
		}
	}
	.ff-upload-parent {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-right: -1px;
		border-right: 1px solid var(--black-10);
	}
	.ff-upload-image-search {
		width: 205.872px;
		border-radius: 8px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		box-shadow: 0px 0px 0px 1px #fff;
		margin-left: 16px;
		margin-bottom: 12px;
		position: relative;
		aspect-ratio: 0.7;
		> img {
			width: 100%;
			height: 100%;
			position: absolute;
			left: auto;
			top: auto;
			backface-visibility: hidden;
			object-fit: contain;
			border-radius: 11px;
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}
		> div {
			color: #000;
			display: flex;
			justify-content: center;
		}
	}
	@media screen and (max-width: 800px) {
		& > .chat-loader {
			& > .ff-chatloader-container {
				width: 86vw !important;
				margin-right: 0 !important;
				margin-left: 36px !important;
			}
		}
		& > .options {
			& > .querytext-holder {
				top: -38px !important;
				margin-right: 2px !important;
				width: 86vw !important;
			}
		}
	}

	& > .chat-loader {
		border-bottom: 1px solid #c6c4c4;
		background-color: #f7f7f7;
		height: 54px;
		display: flex;
		justify-content: center;
		align-items: center;
		& > .ff-chatloader-container {
			width: 70vw;
			justify-content: flex-start;
			margin-right: 36px;
			margin-left: 0;
		}
	}
	& > .options {
		display: flex;
		justify-content: center;
		z-index: 2;
		gap: 10px;
		position: relative;
		height: 0;
		& > .placeholder-filter {
			display: flex;
			visibility: hidden;
			font-size: 13px;
		}
		& > .querytext-holder {
			display: none;
			z-index: 2;
			width: 70vw;
			box-shadow: 0px 3px 6px #00000029;
			border-radius: 7px;
			padding: 16px 0;
			position: absolute;
			top: -7px;
			background: white;
			margin-right: 69px;
			font-family: var(--fontFamily);
			& > .not-found {
				font-family: var(--fontFamily);
				text-align: center;
			}
			& > .user-query-bot-response {
				color: #432325;
				& > div {
					padding: 8px 16px;
					&.user-query {
						padding-left: 42px;
					}
					&.bot-response {
						display: flex;
						align-items: center;
						gap: 10px;
						& > svg {
							min-width: 14px;
						}
						& > div {
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							font-size: 16px;
							font-weight: 500;
							margin: 0;
						}

						&:hover {
							background-color: rgba(0, 0, 0, 0.05) !important;
							cursor: pointer;
						}
					}
				}
			}
			& > hr {
				background: ${(props) =>
					props.colorMode === 'dark'
						? 'var(--colorScale-3)'
						: 'var(--colorScale-0)'};
				height: 1px;
				border: none;
			}
			& > .trending-advisor-holder {
				display: grid;
				grid-template-columns: auto auto;
				padding: 16px;
				font-size: 16px;
				font-family: var(--fontFamily);
				padding-bottom: unset;
				& > .trending {
					> .trending-item {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						margin-bottom: 5px;
						cursor: pointer;
						> div {
							margin-left: 6px;
						}
					}
					& > div:first-child {
						letter-spacing: 0.73px;
						color: ${(props) =>
							props.colorMode === 'dark'
								? 'var(--colorScale-3)'
								: 'var(--colorScale-0)'};
						font-size: 14px;
						margin-bottom: 10px;
					}
				}
				& > .style-advisor {
					& > div:first-child {
						letter-spacing: 0.73px;
						color: ${(props) =>
							props.colorMode === 'dark'
								? 'var(--colorScale-3)'
								: 'var(--colorScale-0)'};
						font-size: 14px;
					}
				}
			}
		}
	}
`;

type Props = {
	token: string;
	tenantId: string;
	botId: string | number;
	country: string;
	secondAPI: boolean;
	colorMode: string;
	encryptText: Function;
	changeToken: Function;
	popUpSnackBar;
	handleToaster;
	enableStyleAdvisor;
	advisorTitle;
	enableTrendingSearch;
	staticDetailsURL;
	enableIntent;
	product_count;
	enableSpeech;
	enableImageUpload;
	enablePDP;
	ecomSearchVertical;
	ecomSearchDetails;
};

const EcomSearch = ({
	token,
	tenantId,
	botId,
	country,
	secondAPI,
	colorMode,
	encryptText,
	changeToken,
	popUpSnackBar,
	handleToaster,
	enableStyleAdvisor,
	advisorTitle,
	enableTrendingSearch,
	staticDetailsURL,
	enableIntent,
	product_count,
	enableSpeech,
	enableImageUpload,
	enablePDP,
	ecomSearchVertical,
	ecomSearchDetails,
}: Props) => {
	const [queryText, setQueryText] = useState('');
	const [showChat, setShowChat] = useState(false);
	const [message, setMessage] = useState('');
	const [time, setTime] = useState('');
	const [loader, setLoader] = useState(false);
	const [metaData, setMetaData] = useState<any>();
	const [chatMessages, setChatMessages] = useState([]);
	const [showExistingQueries, setShowExistingQueries] = useState(false);
	const [showBackButton, setShowBackButton] = useState(false);
	const [showCart, setShowCart] = useState(false);
	const [reasonAPIPayload, setReasonAPIPayload] = useState<any>();
	const [responseId, setResponseId] = useState(0);
	const [filterCheckboxValues, setFilterCheckboxValues] = useState('');
	const [showFilter, setShowFilter] = useState(false);
	const [failedCount, setFailedCount] = useState(0);
	const [trendingSearch, setTrendingSearch] = useState([]);
	const [selectedProductData, setSelectedProductData] = useState<any>();
	const [styleAdvisor, setStyleAdvisor] = useState<any>();
	const [styleAdvisorCache, setStyleAdvisorCache] = useState<any>([]);
	const [title, setTitle] = useState('');
	const [categoriesProductsArray, setCategoriesProductsArray] = useState<any>();
	const [update, setUpdate] = useState(false);
	const [selectedMessageIndex, setSelectedMessageIndex] = useState(0);
	const [topProductsRowsCounter, setTopProductsRowsCounter] = useState(1);
	const [thumbFilledUp, setThumbFilledUp] = useState(null);
	const [feedbackMsgId, setfeedbackMsgId] = useState<any>();
	const [msgId, setMsgId] = useState<any>(null);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [topProductID, setTopProductID] = useState<any>();
	const [enableVoice, setEnableVoice] = useState(false);
	const [enableUpload, setEnableUpload] = useState(false);
	const [userMessage, setUserMessage] = useState('');
	const [disableFilter, setDisableFilter] = useState(false);
	const [filterData, setFilter] = useState<any>([]);
	const [productCount, setProductCount] = useState(0);
	const [currencyCode, setCurrencyCode] = useState('');
	const [uploadedImage, setUploadedImage] = useState('');
	const [pagination, setPagination] = useState(1);
	const screenSize = useScreenSize();
	const deviceType = useScreenType();
	const [previewImage, setPreviewImage] = useState('');
	const [showImageInInput, setShowImageInInput] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const [sortModal, setSortModal] = useState(false);
	const [filterModal, setFilterModal] = useState(false);
	const sortModalRef = useRef(null);
	const filterModalRef = useRef(null);
	const [options, setOptions] = useState([]);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [showPrice, setShowPrice] = useState(false);
	const [filters, setFilters] = useState([]);
	const [filterArray, setFilterArray] = useState<any>({});
	const [paginatedCount, setPaginatedCount] = useState(1);
	const [enablePagination, setEnablePagination] = useState(true);
	const [priceRange, setPriceRange] = useState<number[]>(null);
	const [priceKey, setPriceKey] = useState('');
	const [filterSelected, setFilterSelected] = useState(false);
	const [selectedFilters, setSelectedFilters] = useState({});
	const [priceMin, setPriceMin] = useState(0);
	const [priceMax, setPriceMax] = useState(0);
	const [sortFilter, setSortFilter] = useState({});
	const [filterLoader, setfilterLoader] = useState(false);
	const [errorCode, setErrorCode] = useState('');
	const [mobileBg, setMobileBg] = useState('');
	const [desktopBg, setDesktopBg] = useState('');
	const [mobileLogo, setMobileLogo] = useState('');
	const inputRef = useRef(null);
	const [desktopLogo, setDesktopLogo] = useState('');
	const [disableRandomMsg, setDisableRandomMsg] = useState(false);
	const [resultMessage, setResultMessage] = useState('');
	const [prevFilter, setPrevFilter] = useState<any>(null);
	const [prevPriceRange, setPrevPriceRange] = useState<any>(null);
	const [isFetching, setIsFetching] = useState(false);
	const [activeIndexSort, setActiveIndexSort] = useState(0);
	const [isLogoPassed, setLogoPassed] = useState(false);
	const sortOptions = [
		{ value: 'Relevance', label: 'Relevance', icon: <SortTick /> },
		{
			value: 'Price: Low to High',
			label: 'Price: Low to High',
			icon: <SortTick />,
		},
		{
			value: 'Price: High to Low',
			label: 'Price: High to Low',
			icon: <SortTick />,
		},
	];
	const [selectedSortOption, setSelectedSortOption] = useState(sortOptions[0]);
	useOutsideClick(filterModalRef, setFilterModal);
	useOutsideClick(sortModalRef, setSortModal);

	const sortBy = ['Relevance', 'Price: Low to high', 'Price: high to low'];
	useEffect(() => {
		if (failedCount === 1) {
			restartSession();
		}
	}, [failedCount]);

	useEffect(() => {
		// console.log(
		//   ecomSearchDetails.ecomSearchMobileLogo,
		//   ecomSearchDetails.ecomSearchDesktopLogo
		// );
		// if (
		//   deviceType === "mobile" ||
		//   (deviceType === "tablet" && screenSize < 800)
		// ) {
		//   if (
		//     ecomSearchDetails.ecomSearchMobileLogo &&
		//     ecomSearchDetails.ecomSearchMobileLogo.length > 0
		//   ) {
		//     setLogoPassed(true);
		//   } else {
		//     setLogoPassed(false);
		//   }
		// } else {
		if (
			ecomSearchDetails.ecomSearchDesktopLogo &&
			ecomSearchDetails.ecomSearchDesktopLogo.length > 0
		) {
			setLogoPassed(true);
		} else {
			setLogoPassed(false);
		}
		// }
	}, [ecomSearchDetails]);

	const filterRef = useRef(null);
	const optionsRef = useRef(null);

	const handleOptionClick = (filterIndex, option, product_type) => {
		const selectedKey = `${filterIndex}-${option}`; // Unique key for each option
		setSelectedOptions((prevSelected) =>
			prevSelected.some((item) => item.key === selectedKey)
				? prevSelected.filter((item) => item.key !== selectedKey)
				: [
						...prevSelected,
						{ key: selectedKey, filterIndex, option, product_type },
				  ]
		);
	};

	const handleCheckboxChange = () => {
		setPrevFilter(selectedOptions);
		if (priceRange && priceRange[1] !== 0) {
			setPrevPriceRange(priceRange);
		}
		const filters = {};

		selectedOptions.forEach((item) => {
			const { product_type, option } = item;

			if (!filters[product_type]) {
				filters[product_type] = [];
			}

			// Avoid duplicates
			if (!filters[product_type].includes(option)) {
				filters[product_type].push(option);
			}
		});
		if (priceRange) {
			filters['sale_price'] = { min: priceRange[0], max: priceRange[1] };
		}
		// saveStateSession('filters', updatedFilter);
		handleFilter(filters);

		// setSelectedFilters((prevFilters) => {
		// 	const currentValues = prevFilters[filterCaption] || [];
		// 	if (currentValues.includes(value)) {
		// 		// Remove value if already selected
		// 		let updatedFilters = {
		// 			...prevFilters,
		// 			[filterCaption]: currentValues.filter((item) => item !== value),
		// 		};
		// 		if (updatedFilters[filterCaption].length === 0) {
		// 			delete updatedFilters[filterCaption];
		// 		}
		// 		return updatedFilters;
		// 	} else {
		// 		// Add value if not selected
		// 		return {
		// 			...prevFilters,
		// 			[filterCaption]: [...currentValues, value],
		// 		};
		// 	}
		// });
	};

	const openThumbsPopup = (val, up, id) => {
		setThumbFilledUp(up);
		setfeedbackMsgId(id);
		setIsModalVisible(val);
	};

	const storeStyle = () => {
		if (styleAdvisor.length > 0)
			setStyleAdvisorCache([
				...styleAdvisorCache,
				{ id: loadStateSession('FF-productID'), data: styleAdvisor },
			]);
	};
	const uploadImageResp = (response) => {
		setUploadedImage(response.image_url);
		let queryFromPD = false;
		if (showBackButton) {
			queryFromPD = true;
		} else {
			queryFromPD = false;
		}
		let message = [];
		let chatMessageDataUser = {
			message: queryText,
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'user',
			customInfos: {},
			suggestionChips: [],
		};

		setFailedCount(0);
		setMsgId(response.messageId);
		setFilter(response.metaData.filters);
		setPaginatedCount(1);
		setProductCount(response.metaData.total_product_count);
		let chatMessageDataServer = {
			message: response,
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'server',
			customInfos: {},
			suggestionChips: [],
			conversationalId: response.id,
			thumbFilledUp: null,
			messageId: response.messageId,
		};
		setCurrencyCode(
			response.metaData.products &&
				response.metaData.products.length > 0 &&
				response.metaData.products[0].currency
		);
		setResponseId(response.id); // same as conversation id hence using the same not using from App.tsx
		setTime(chatMessageDataServer.timeStamp);
		if (response.message.toLowerCase().indexOf('something went wrong') > -1) {
			setMessage(
				'We are facing some technical issues in getting the result. Please try again'
			);
		} else {
			setMessage(response.message);
		}
		if (
			(response.metaData.products && response.metaData.products.length > 0) ||
			!queryFromPD
		) {
			const topProductIds = new Set(
				response.metaData.products
					.filter(
						(product) => product.category.toLowerCase() === 'top products'
					)
					.map((product) => product.product_id)
			);
			setTopProductID(topProductIds);
			!productCount && setProductCount(response.metaData.total_product_count);
			setMetaData(response.metaData);
			setCategoriesProductsArray([
				{
					category:
						response.metaData &&
						response.metaData.categories &&
						response.metaData.categories[0],
					products: response.metaData && response.metaData.products,
					rows: 2,
				},
			]);
		}

		message.push({ chatMessageDataUser, chatMessageDataServer });
		setChatMessages((prev) => [...prev, message]);
	};
	// useEffect(() => {
	// 	let updatedData;
	// 	if (filterSelected) {
	// 		if (Object.keys(selectedFilters).length !== 0) {
	// 			const priceFilter = filterData.find((item) => (item.hasOwnProperty("price"))) ? filterData.find((item) => (item.hasOwnProperty("price"))).price : filterData.find((item) => (item.hasOwnProperty("sale_price"))).sale_price;
	// 			const keyName = filterData.find((item) => (item.hasOwnProperty("price"))) ? 'price' : 'sale_price';
	// 			updatedData = {
	// 				...selectedFilters,
	// 				[keyName.toString()]: {
	// 					min: priceRange
	// 						? priceRange[0]
	// 						: priceFilter.min,
	// 					max: priceRange
	// 						? priceRange[1]
	// 						: priceFilter.max,
	// 				},
	// 			};
	// 		} else {
	// 			if (filterSelected) {
	// 				updatedData = {};
	// 			}
	// 		}
	// 		setUpdatedFilter(updatedData)

	// 		//	handleFilter(updatedData);
	// 	}
	// }, [selectedFilters]);
	const nextPage = () => {
		if (isFetching === false) {
			setTimeout(() => {
				setPagination((prevPagination) => {
					const newPagination = prevPagination + 1;

					return newPagination;
				});
			}, 0);
		}
	};

	const handleFilter = (filterJSON) => {
		setFilterArray(filterJSON);
		setfilterLoader(true);
		setErrorCode('');
		let queryFromPD = false;
		if (showBackButton) {
			queryFromPD = true;
		} else {
			queryFromPD = false;
		}
		let message = [];
		let chatMessageDataUser = {
			message: queryText,
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'user',
			customInfos: {},
			suggestionChips: [],
		};
		let headers = {
			'Content-Type': 'application/json',
			'x-tenant-id': tenantId,
			Authorization: `Bearer ${token}`,
		};
		Axios.post(
			window['BASE_URL'] + '/conversation/filter',
			{
				id: responseId,
				message: queryText,
				botId: botId.toString(),
				msg_id: msgId,
				page_no: 1,
				filters: filterJSON,
				sort: sortFilter,
			},

			{
				headers: headers,
			}
		)
			.then((resp: any) => {
				let response = resp.data;
				setSelectedProductData('');
				//setFilter(response.metaData.filters);

				if (response.status && response.status.toLowerCase() !== 'success') {
					throw new Error(response.message);
				}

				if (!response.status) {
					throw new Error(response.message);
				}
				if (response.status.toLowerCase() === 'success') {
					setFailedCount(0);
					setMsgId(response.messageId);

					let chatMessageDataServer = {
						message: response,
						timeStamp: TimeUtil.getCurrentTime(new Date()),
						key: null,
						messageType: 'server',
						customInfos: {},
						suggestionChips: [],
						conversationalId: response.id,
						thumbFilledUp: null,
						messageId: response.messageId,
					};
					setResponseId(response.id); // same as conversation id hence using the same not using from App.tsx
					setTime(chatMessageDataServer.timeStamp);
					if (
						response.message.toLowerCase().indexOf('something went wrong') > -1
					) {
						setMessage(
							'We are facing some technical issues in getting the result. Please try again'
						);
					} else {
						setMessage(response.message);
					}
					if (
						(response.metaData.products &&
							response.metaData.products.length > 0) ||
						!queryFromPD
					) {
						const topProductIds = new Set(
							response.metaData.products
								.filter(
									(product) => product.category.toLowerCase() === 'top products'
								)
								.map((product) => product.product_id)
						);
						setTopProductID(topProductIds);
						setLoader(false);
						setfilterLoader(false);
						setProductCount(response.metaData.total_product_count);

						setPagination(1);
						setCategoriesProductsArray([
							{
								category:
									response.metaData &&
									response.metaData.categories &&
									response.metaData.categories[0],
								products: response.metaData && response.metaData.products,
								rows: 2,
							},
						]);
						if (
							response.metaData.total_product_count <= parseInt(product_count)
						) {
							setfilterLoader(false);
						} else {
							nextPage();
						}

						setMetaData(response.metaData);
					}
					setLoader(false);
					message.push({ chatMessageDataUser, chatMessageDataServer });
					setChatMessages((prev) => [...prev, message]);
				}
			})
			.catch((error) => {
				// setLoader(false)
				let errorStatus = error.response?.status;
				setfilterLoader(false);
				setErrorCode(errorStatus.toString());
				// setfilterLoader(false)
			});
	};
	const submitChat = (messageId?, convID?, chatInput?) => {
		setMetaData('');
		setShowChat(false);
		setSelectedSortOption(sortOptions[0]);
		setDisableRandomMsg(false);
		setErrorCode('');
		setSelectedFilters({});
		let queryFromPD = false;
		setUploadedImage('');
		setShowExistingQueries(false);
		setFilterArray({});
		setSortFilter({});
		setPagination(1);
		setPrevFilter([]);
		setShowCart(false);
		setActiveIndex(0);
		setFilters([]);
		setOptions([]);
		setPrevPriceRange(null);
		setShowPrice(false);
		setActiveIndexSort(0);
		if (showBackButton) {
			queryFromPD = true;
		} else {
			queryFromPD = false;
		}
		setShowBackButton(false);

		let message = [];
		let chatMessageDataUser = {
			message: queryText,
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'user',
			customInfos: {},
			suggestionChips: [],
		};
		if (deviceType == 'desktop') {
			setUserMessage('');
		}
		let payload = {
			id: convID ? convID : responseId,
			message: chatInput ? chatInput : queryText,
			botId: botId.toString(),
			version: 'prod',
			country: country,
			metaData: selectedProductData ? selectedProductData : {},
			msg_id: messageId ? messageId : msgId ? msgId : null,
		};
		setResultMessage(chatInput ? chatInput : queryText);
		setReasonAPIPayload(payload);
		if (!convID) {
			setLoader(true);
		}
		fetch(
			window['BASE_URL'] +
				(loadStateSession('message_api_url') ?? '/messages/'),
			{
				// credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(payload),
			}
		)
			.then((data) => data.json())
			.then((response) => {
				setSelectedOptions([]);
				setSelectedProductData('');
				if (response.status && response.status.toLowerCase() !== 'success') {
					throw new Error(response.message);
				}
				if (!response.status) {
					throw new Error(response.message);
				}
				if (response.status.toLowerCase() === 'success') {
					setFailedCount(0);
					setFilter(response.metaData.filters);
					setMsgId(response.messageId);
					setProductCount(response.metaData.total_product_count);

					let chatMessageDataServer = {
						message: response,
						timeStamp: TimeUtil.getCurrentTime(new Date()),
						key: null,
						messageType: 'server',
						customInfos: {},
						suggestionChips: [],
						conversationalId: response.id,
						thumbFilledUp: null,
						messageId: response.messageId,
					};
					setResponseId(response.id); // same as conversation id hence using the same not using from App.tsx
					setTime(chatMessageDataServer.timeStamp);
					if (
						response.message.toLowerCase().indexOf('something went wrong') > -1
					) {
						setMessage(
							'We are facing some technical issues in getting the result. Please try again'
						);
					} else {
						setMessage(response.message);
					}

					if (
						response.metaData.products &&
						response.metaData.products.length > 0
					) {
						!productCount &&
							setProductCount(response.metaData.total_product_count);
						setCurrencyCode(
							response.metaData.products &&
								response.metaData.products.length > 0 &&
								response.metaData.products[0].currency
						);
						const topProductIds = new Set(
							response.metaData.products
								.filter(
									(product) => product.category.toLowerCase() === 'top products'
								)
								.map((product) => product.product_id)
						);
						setTopProductID(topProductIds);
						setMetaData(response.metaData);
						setFilters(response.metaData.filters);
						const priceFilter =
							response.metaData &&
							response.metaData.filters.find(
								(item) =>
									item.hasOwnProperty('price') ||
									item.hasOwnProperty('sale_price')
							);
						const keyName = Object.keys(priceFilter).filter(
							(key) => key !== 'filter_caption'
						);
						setPriceMin(priceFilter[keyName.toString()].min);
						setPriceMax(priceFilter[keyName.toString()].max);
						setPriceRange([
							priceFilter[keyName.toString()].min,
							priceFilter[keyName.toString()].max,
						]);

						setPriceKey(keyName.toString());
						setCategoriesProductsArray([
							{
								category:
									response.metaData &&
									response.metaData.categories &&
									response.metaData.categories[0],
								products: response.metaData && response.metaData.products,
								rows: 2,
							},
						]);
					}

					message.push({ chatMessageDataUser, chatMessageDataServer });
					setChatMessages((prev) => [...prev, message]);

					if (
						response.metaData.filters &&
						response.metaData.filters.length > 0
					) {
						let firstOption = Object.keys(response.metaData.filters[0]).filter(
							(item) => item !== 'filter_caption'
						)[0];
						setOptions(response.metaData.filters[0][firstOption]);
					}
					setShowChat(true);

					setLoader(false);
				}
			})
			.catch((error) => {
				let offlineMessage;
				setFailedCount(failedCount + 1);

				if (error.message) {
					offlineMessage = error.message;
					if (
						error.message.toLowerCase() === 'failed to fetch' &&
						failedCount !== 1
					) {
						offlineMessage = `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`;
					}
				}

				if (!navigator.onLine) {
					setMessage('Seems like you are not connected to a network.');
				} else {
					if (failedCount !== 1) {
						setMessage(
							offlineMessage.length > 0
								? offlineMessage
								: `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`
						);
					}
				}
				setShowChat(true);
				setLoader(false);
				setTime(TimeUtil.getCurrentTime(new Date()));
				setMetaData('');
			});
	};
	useEffect(() => {
		if (showChat) {
			document
				.querySelector('.ff-sort-by input')
				.setAttribute('readOnly', 'true');
		}
	}, [showChat]);
	useEffect(() => {
		function handleClickOutside(event) {
			if (filterRef.current && !filterRef.current.contains(event.target)) {
				setShowFilter(false);
			}
			if (optionsRef.current && !optionsRef.current.contains(event.target)) {
				setShowExistingQueries(false);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [filterRef, optionsRef]);
	const showBack = () => {
		setShowBackButton(true);
		setTitle('');
	};
	const handleStyleAdvisor = (product_id, product_name) => {
		setStyleAdvisor('');
		Axios.post(
			window['BASE_URL'] + `/conversation/style_advisor`,
			{
				product_id: [product_id],
				botId: botId.toString(),
				version: 'prod',
				id: responseId,
				messageId: msgId,
				message: queryText,
			},
			{
				headers: {
					'x-tenant-id': tenantId.toString(),
					Authorization: `Bearer ${loadStateSession('token')}`,
				},
			}
		).then((response) => {
			const resp = response.data.style_advisor_products;
			//	getStyleAdvisor(resp, product_id);
			// setComplimentaryProducts(resp)
			let filteredStyle;
			if (resp) {
				filteredStyle = resp.filter(
					(product) => !topProductID.has(product.productId)
				);
			}
			resp.length &&
				setStyleAdvisor((styleAdvisor) => [...styleAdvisor, filteredStyle]);
		});
	};

	const getStyleAdvisor = (resp, product_id) => {
		// let data = { data: styleAdvisor, id: product_id };
		let length = resp.complimentary_products.length - 1;

		Axios.post(
			window['BASE_URL'] + `/search/semantic`,
			{
				input_text: '',
				tenant_id: tenantId.toString(),
				bot_id: botId.toString(),
				version: 'prod',
				generic_response: '',
				product_intent: '',
				queries: resp.complimentary_products,
				source: 'webs',
				conversationId: responseId,
				messageId: msgId,
			},
			{
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
			}
		).then((resp) => {
			let filteredStyle;
			if (resp.data.similar_content.length) {
				filteredStyle = resp.data.similar_content.filter(
					(product) => !topProductID.has(product.productId)
				);
			}
			resp.data.similar_content.length &&
				setStyleAdvisor((styleAdvisor) => [...styleAdvisor, filteredStyle]);
		});
	};
	const restartSession = () => {
		var date = new Date();
		var timestamp = Math.floor(date.getTime() / 1000.0);
		var usertenantID = encryptText(`${tenantId}:${timestamp}`);
		const endpoint =
			window.location.origin.indexOf('localhost') > -1 ||
			window.location.origin.indexOf('https://dev.flyfish.ai') > -1
				? window['BASE_URL']
				: window.location.origin.indexOf('uat.flyfish.ai') > -1
				? 'https://uat.flyfish.ai'
				: window.location.origin.indexOf('preprod.flyfish.ai') > -1
				? 'https://preprod.flyfish.ai'
				: window['BASE_URL'];
		Axios.post(
			endpoint + `/authentication/anonynousLogin`,
			{
				name: 'anonymous',
				email: 'anonymousEmail',
				teamId: usertenantID,
			},
			{
				headers: {
					'x-tenant-id': tenantId,
				},
			}
		).then((response) => {
			let token = response.data.data.token;
			changeToken(token);
			queryText && submitChat();
			// let sessionIDFORM = response.data.data.createdTime;
		});
	};
	const showCartData = () => {
		setShowCart(true);
		setDisableFilter(true);
	};

	const getTitleMessage = (title) => {
		setTitle(title);
	};
	const submitFeedback = (star = false, comment = '', msgRate, msgId) => {
		setIsModalVisible(false);
		let payload = {
			id: 0,
			conversationId: responseId,
			messageId: msgId ? msgId : 0,
			botId: botId,
			rating: star,
			msgRating: msgRate ? msgRate : 0,
			feedBackText: comment,
		};
		fetch(
			'https://' + window['CHAT_URL'] + `/configuration/${tenantId}/feedBack`,
			{
				credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify(payload),
			}
		)
			.then((data) => data.json())
			.then((response) => {
				handleToaster();
			});
		const updatedData = chatMessages.map((item) => {
			return item.map((type) => {
				if (type.chatMessageDataServer.messageId === msgId) {
					return {
						...type,
						chatMessageDataServer: {
							...type.chatMessageDataServer,
							thumbFilledUp: thumbFilledUp,
						},
					};
				}

				return type;
			});
		});
		setChatMessages(updatedData);
		if (msgRate > 0) {
		}
	};

	useEffect(() => {
		if (pagination === 1) {
			setPaginatedCount(1);
		}

		if (
			pagination > 1 &&
			paginatedCount < productCount &&
			productCount >= product_count
		) {
			//	setLoader(true)
			setErrorCode('');
			setPaginatedCount(pagination * product_count); //calc for checking how many products fetched
			let headers = {
				'Content-Type': 'application/json',
				'x-tenant-id': tenantId,
				Authorization: `Bearer ${token}`,
			};
			Axios.post(
				window['BASE_URL'] + '/conversation/filter',
				{
					id: responseId,
					message: queryText,
					botId: botId.toString(),
					msg_id: msgId,
					page_no: pagination,
					filters: filterArray ? filterArray : {},
					sort: sortFilter,
				},
				{
					headers: headers,
				}
			)
				.then((response: any) => {
					if (loader) {
						setLoader(false);
					}
					if (filterLoader) {
						setfilterLoader(false);
					}
					if (response.data.metaData?.products.length > 0) {
						setCategoriesProductsArray((prevArray) => {
							return prevArray.map((item) => ({
								...item,
								products: [
									...(item.products || []), // Preserve existing products
									...(response.data.metaData?.products || []), // Append new products
								],
							}));
						});
					}
				})
				.catch((error) => {
					let errorStatus = error.response?.status;
					setfilterLoader(false);
					setErrorCode(errorStatus.toString());
					// setLoader(false)
					// setfilterLoader(false)
				})
				.finally(() => {
					setIsFetching(false);
				});
		}
	}, [pagination]);

	const handleChange = (event) => {
		setSelectedSortOption(event);
	};
	const handleSort = (data) => {
		setSortFilter(data);
		setfilterLoader(true);
		setErrorCode('');
		setPagination(1);
		//setLoader(true)
		let queryFromPD = false;
		if (showBackButton) {
			queryFromPD = true;
		} else {
			queryFromPD = false;
		}
		let message = [];
		let chatMessageDataUser = {
			message: queryText,
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'user',
			customInfos: {},
			suggestionChips: [],
		};
		let headers = {
			'Content-Type': 'application/json',
			'x-tenant-id': tenantId,
			Authorization: `Bearer ${token}`,
		};
		Axios.post(
			window['BASE_URL'] + '/conversation/filter',
			{
				id: responseId,
				message: queryText,
				botId: botId.toString(),
				msg_id: msgId,
				page_no: 1,
				filters: filterArray ? filterArray : {},
				sort: data,
			},
			{
				headers: headers,
			}
		)
			.then((resp: any) => {
				let response = resp.data;
				setSelectedProductData('');
				setfilterLoader(false);
				setLoader(false);

				if (response.status && response.status.toLowerCase() !== 'success') {
					throw new Error(response.message);
				}

				if (!response.status) {
					throw new Error(response.message);
				}
				if (response.status.toLowerCase() === 'success') {
					setFailedCount(0);
					setMsgId(response.messageId);

					let chatMessageDataServer = {
						message: response,
						timeStamp: TimeUtil.getCurrentTime(new Date()),
						key: null,
						messageType: 'server',
						customInfos: {},
						suggestionChips: [],
						conversationalId: response.id,
						thumbFilledUp: null,
						messageId: response.messageId,
					};
					setResponseId(response.id); // same as conversation id hence using the same not using from App.tsx
					setTime(chatMessageDataServer.timeStamp);

					if (
						response.metaData.total_product_count <= parseInt(product_count)
					) {
						setfilterLoader(false);
					}
					if (
						response.message.toLowerCase().indexOf('something went wrong') > -1
					) {
						setMessage(
							'We are facing some technical issues in getting the result. Please try again'
						);
					} else {
						setMessage(response.message);
					}
					if (
						(response.metaData.products &&
							response.metaData.products.length > 0) ||
						!queryFromPD
					) {
						const topProductIds = new Set(
							response.metaData.products
								.filter(
									(product) => product.category.toLowerCase() === 'top products'
								)
								.map((product) => product.product_id)
						);
						setTopProductID(topProductIds);
						setTopProductID(topProductIds);
						!productCount &&
							setProductCount(response.metaData.total_product_count);
						setMetaData(response.metaData);
						setCategoriesProductsArray([
							{
								category:
									response.metaData &&
									response.metaData.categories &&
									response.metaData.categories[0],
								products: response.metaData && response.metaData.products,
								rows: 2,
							},
						]);
					}

					message.push({ chatMessageDataUser, chatMessageDataServer });
					setChatMessages((prev) => [...prev, message]);
				}
			})
			.catch((error) => {
				let errorStatus = error.response?.status;
				setfilterLoader(false);
				setErrorCode(errorStatus.toString());
				// setLoader(false)
				// setfilterLoader(false)
			});
	};
	// useEffect(() => {
	// 	if () {
	// 		setEnablePagination(true);
	// 	}
	// 	else {
	// 		setEnablePagination(false);
	// 	}
	// }, [paginatedCount])

	const getIntent = (query?) => {
		setLoader(true);
		// setQueryText('');
		setErrorCode('');
		setShowChat(false);
		let payload = {
			id: responseId,
			message: query ? query : queryText,
			botId: botId.toString(),
			version: 'prod',
			country: loadStateSession('FS-country'),
			metaData: selectedProductData
				? selectedProductData
				: { productID: '', productName: '' },
			userId: loadStateSession('userId'),
		};

		fetch(window['BASE_URL'] + '/conversation/message/intent', {
			// credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-tenant-id': tenantId,
				Authorization: `Bearer ${loadStateSession('token')}`,
			},
			body: JSON.stringify(payload),
		})
			.then((data) => {
				return data.json();
			})
			.then((resp) => {
				let response = resp;
				setMsgId(response.messageId);
				setResponseId(response.id);
				submitChat(response.messageId, response.id, query ? query : queryText);
			})
			.catch((error) => {});
	};
	const fetchConfig = async () => {
		try {
			console.warn('Fetching config...');
			const timestamp = new Date().getTime();
			const response = await fetch(
				window['BASE_URL'] + `/Fullscreen/Config/Config.json?t=${timestamp}`
			);
			const data = await response.json();
			setMobileBg(data.ECOMSearchbgMobile);
			setDesktopBg(data.ECOMSearchbg);
			setMobileLogo(data.ECOMSearchLogoMobile);
			setDesktopLogo(data.ECOMSearchLogoDesktop);
		} catch (error) {
			console.error('Error fetching config:', error);
		} finally {
		}
	};

	useEffect(() => {
		fetchConfig();
	}, []);

	const getHighestSalePrice = (products) => {
		const salePrices = products
			.filter((product) => product.sale_price != null) // Filter products with sale_price
			.map((product) => product.sale_price); // Extract sale_price values

		return salePrices.length > 0 ? Math.max(...salePrices) : null; // Get the highest price or null if no valid prices
	};
	const getLowestSalePrice = (products) => {
		const salePrices = products
			.filter((product) => product.sale_price != null)
			.map((product) => product.sale_price);

		return salePrices.length > 0 ? Math.min(...salePrices) : 'No Sale Prices';
	};
	return (
		<EcomSearcContainer className={`ff-ecom-search-container`}>
			<EcomInput
				className={`ff-ecom-container ${deviceType} ${
					showImageInInput ? 'showImage' : ''
				} ${
					isLogoPassed
						? 'adjust-header'
						: deviceType === 'mobile'
						? 'adjust-mobile-header'
						: ''
				}
          `}
				screenSize={screenSize}
			>
				{showCart && deviceType === 'mobile' ? (
					<svg
						onClick={() => setShowCart(false)}
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<g id='arrow_back'>
							<path
								id='Vector'
								d='M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z'
								fill='black'
							/>
						</g>
					</svg>
				) : (
					<img
						src={
							deviceType === 'mobile' ||
							(deviceType === 'tablet' && screenSize < 800)
								? ecomSearchDetails.ecomSearchMobileLogo
									? ecomSearchDetails.ecomSearchMobileLogo
									: ''
								: ecomSearchDetails.ecomSearchDesktopLogo
								? ecomSearchDetails.ecomSearchDesktopLogo
								: ''
						}
					/>
				)}
				<Input
					className='ff-ecom-input'
					ref={inputRef}
					placeholder={
						deviceType === 'mobile' || deviceType === 'tablet'
							? ecomSearchDetails.ecomSearchMobilePlaceholder &&
							  ecomSearchDetails.ecomSearchMobilePlaceholder
							: ecomSearchDetails.ecomSearchDesktopPlaceholder &&
							  ecomSearchDetails.ecomSearchDesktopPlaceholder
					}
					autoComplete='off'
					value={userMessage}
					// onClick={() => {
					// 	setShowExistingQueries(!showExistingQueries);
					// }}
					onChange={(ev) => {
						setShowExistingQueries(false);
						setQueryText(ev.target.value.trimStart());
						if (showImageInInput) {
							setShowImageInInput(false);
						}
						setUserMessage(ev.target.value.trimStart());
					}}
					onKeyDown={(e) => {
						if (e.key.toLowerCase() === 'enter') {
							if (enableIntent) {
								getIntent();
							} else {
								queryText.trimStart().length && submitChat();
							}
							// @ts-ignore
							e.target.blur();
						}
					}}
					endIcon={
						<div>
							{userMessage.length > 0 && (
								<InteractiveButton
									icon={<CloseInput />}
									onClick={() => {
										setUserMessage('');
										setPreviewImage('');
										setShowImageInInput(false);
										inputRef.current?.focus();
									}}
								></InteractiveButton>
							)}
							{userMessage.length == 0 && (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									{enableImageUpload ? (
										<InteractiveButton
											icon={<UploadImage />}
											onClick={() => {
												setEnableUpload(true);
											}}
										></InteractiveButton>
									) : null}

									{enableSpeech ? (
										<InteractiveButton
											icon={<MicIcon />}
											onClick={() => {
												setEnableVoice(true);
											}}
										></InteractiveButton>
									) : null}
								</div>
							)}
						</div>
					}
					imagePreview={
						queryText.toLowerCase().indexOf('image:') > -1 && previewImage
					}
				/>
				{showChat && !showCart ? (
					<div className={`ff-sort-by ff-chatbot-body2 ${deviceType}`}>
						<div style={{ marginRight: '12px' }}>Sort by</div>
						<AutoComplete
							multiple={false}
							value={selectedSortOption}
							options={sortOptions}
							valueKey={'value'}
							labelKey={'label'}
							classNameOndropLI={'ff-ecom-search-dropdown'}
							iconKey='icon'
							onChange={(val) => {
								saveStateSession('ff-sortFilter', val);
								handleChange(val);
								setDisableRandomMsg(true);
								if (val.value !== 'Relevance') {
									handleSort({
										column: priceKey.length > 0 ? priceKey : 'price',
										order: val.value === 'Price: Low to High' ? 'asc' : 'desc',
									});
								} else {
									handleSort({});
								}
							}}
						/>
					</div>
				) : null}
				{/* {deviceType === 'mobile' ||
					(deviceType === 'tablet' && screenSize < 800) ? (
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<g id='menu'>
							<path
								id='Vector'
								d='M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z'
								fill='black'
							/>
						</g>
					</svg>
				) : null} */}
			</EcomInput>
			{showChat || loader ? null : (
				<div className='ff-hero-container'>
					{ecomSearchDetails.ecomSearchMobileBg.length > 0 ||
					ecomSearchDetails.ecomSearchDesktopBg.length > 0 ? (
						<img
							src={
								deviceType === 'mobile' ||
								(deviceType === 'tablet' && screenSize < 800)
									? ecomSearchDetails.ecomSearchMobileBg
										? ecomSearchDetails.ecomSearchMobileBg
										: ''
									: ecomSearchDetails.ecomSearchDesktopBg
									? ecomSearchDetails.ecomSearchDesktopBg
									: ''
							}
						/>
					) : null}

					{/* {deviceType === 'mobile' ||
					(deviceType === 'tablet' && screenSize < 800) ? (
						<div>
							<Carousel
								showStatus={false}
								showThumbs={false}
								showIndicators={false}
								emulateTouch={true}
								centerMode={true}
								centerSlidePercentage={53.44}
								className='custom-carousel'
							>
								{Array.from({ length: 3 }, (_, index) => (
									<div className='carousel-item'>
										<img
											src={index === 0 ? Card1 : index === 1 ? Card2 : Card3}
											alt=''
										/>
									</div>
								))}
							</Carousel>
						</div>
					) : null} */}
				</div>
			)}
			<EcomContainer
				colorMode={colorMode}
				queriesFound={chatMessages.length > 0}
				className='ff-ecom-theme-container'
			>
				{/* {showChat && !showCart ? (
					<div className={`ff-sort-by ff-chatbot-body2 ${deviceType}`}>
						<div style={{ marginRight: '12px' }}>Sort by</div>
						<AutoComplete
							multiple={false}
							value={selectedSortOption}
							options={sortOptions}
							valueKey={'value'}
							labelKey={'label'}
							classNameOndropLI={'ff-ecom-search-dropdown'}
							iconKey='icon'
							onChange={(val) => {
								saveStateSession('ff-sortFilter', val);
								handleChange(val);
								setDisableRandomMsg(true);
								if (val.value !== 'Relevance') {
									handleSort({
										column: priceKey.length > 0 ? priceKey : 'price',
										order: val.value === 'Price: Low to High' ? 'asc' : 'desc',
									});
								} else {
									handleSort({});
								}
							}}
						/>
					</div>
				) : null} */}
				{errorCode && errorCode.length > 0 && chatMessages.length == 0 && (
					<div
						style={{
							display: 'grid',
							gridTemplateColumns: 'auto',
							paddingTop: '24px',
							width: 'calc(100%)',
							gap: '12px',
							height: '100vh',
							backgroundColor: '#faf8fc',
							justifyContent: 'center',
							marginTop: '10px',
						}}
					>
						<div
							style={{
								color: 'var(--black-60)',
								height: '100%',
								display: 'flex',
								alignItems: 'flex-start',
								justifyContent: 'center',
							}}
							className='ff-chatbot-body1'
						>
							"We are currently facing an issue (Error Code: {errorCode}).
							Please try again later."
						</div>
					</div>
				)}
				<>
					{loader ? (
						<div
							style={{
								display: 'grid',
								gridTemplateColumns:
									chatMessages.length > 0 && deviceType === 'desktop'
										? '234px auto'
										: 'auto',
							}}
						>
							{chatMessages.length > 0 && deviceType === 'desktop' ? (
								<div
									className={`ff-side-filter-content ${deviceType} ${
										showCart ? 'ff-cart-page' : ''
									}`}
								>
									<div className={`side-filter ${deviceType}`}></div>
								</div>
							) : null}
							<ProductLoader
								disableMsg={disableRandomMsg}
								ecomSearchVertical={ecomSearchVertical}
							/>

							{/* <LoaderWrapperParent
								className={`ff-loader-wrapper-parent ${deviceType}`}
							>
								{deviceType === 'desktop' ? (
									<div className='ff-fashion-tip'>{randomMessage}</div>
								) : null}
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										gap: '8px',
									}}
								>
									{Array.from({ length: 4 }, (_, index) => (
										<>
											{deviceType !== 'desktop' && index === 2 ? (
												<div className='ff-fashion-tip'>{randomMessage}</div>
											) : null}
											<LoaderWrapper className='ff-loader-card' >
												<div className='ff-lottie-container'>
													<div className='ff-lottie'>
														{index === 0 && ImageOneSVG &&
															<div>
																<ImageOneSVG
																	color={imageOneColor}
																	preserveAspectRatio="xMidYMid meet"
																	style={{
																		width: '100%',
																		height: '100%',
																		position: 'absolute',
																		top: '-2px',
																		opacity: showSvg ? '1' : '0'
																	}}

																/>
															</div>
														}
														{index === 1 && ImageTwoSVG &&
															<div>
																<ImageTwoSVG
																	color={imageTwoColor}
																	preserveAspectRatio="xMidYMid meet"
																	style={{
																		width: '100%',
																		height: '100%',
																		position: 'absolute',
																		top: '-2px',
																		opacity: showSvg ? '1' : '0'
																	}}

																/>
															</div>
														}
														{index === 2 && ImageThreeSVG &&
															<div>
																<ImageThreeSVG
																	color={imageThreeColor}
																	preserveAspectRatio="xMidYMid meet"
																	style={{
																		width: '100%',
																		height: '100%',
																		position: 'absolute',
																		top: '-2px',
																		opacity: showSvg ? '1' : '0'
																	}}

																/>
															</div>
														}

														{index === 3 && ImageFourSVG &&
															<div>
																<ImageFourSVG
																	color={imageFourColor}
																	preserveAspectRatio="xMidYMid meet"
																	style={{
																		width: '100%',
																		height: '100%',
																		position: 'absolute',
																		top: '-2px',
																		opacity: showSvg ? '1' : '0'
																	}}

																/>
															</div>
														}
														<div
															style={{ opacity: !showSvg ? '1' : '0' }}
															ref={index == 0 ? imageOneRef : index == 1 ? imageTwoRef : index == 2 ? imageThreeRef : imageFourRef}></div>
													</div>
												</div>
											</LoaderWrapper>
										</>
									))}
								</div>
							</LoaderWrapperParent> */}
						</div>
					) : (
						// <div className='chat-loader'>
						// 	<ChatLoader />
						// </div>
						<>
							{showChat ? (
								<div
									className={`ff-side-filter-content ${deviceType} ${
										showCart ? 'showCart' : ''
									}`}
								>
									<div
										className={`side-filter ${deviceType} ${
											isLogoPassed ? '' : 'adjust-filter'
										}`}
										style={{
											display:
												!showCart && deviceType === 'desktop'
													? 'block'
													: 'none',
										}}
									>
										{uploadedImage.length > 0 ? (
											<div className='ff-upload-parent'>
												<div className='ff-upload-image-search'>
													<img src={uploadedImage} />
												</div>
												<div
													className='ff-chatbot-body1'
													style={{
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center',
													}}
												>
													Your Image
												</div>
												<div
													className='ff-chatbot-caption'
													style={{
														color: 'var(--black-50, rgba(0, 0, 0, 0.50))',
														marginTop: '3px',
													}}
												>{`${productCount} similar products found`}</div>
											</div>
										) : null}

										<EcomFilter
											filterData={filterData}
											queryText={userMessage}
											id={responseId}
											msgId={msgId}
											handleFilter={handleFilter}
											currency={currencyCode}
											productCount={productCount}
											resultMessage={resultMessage}
											uploadedImage={uploadedImage.length > 0 ? true : false}
											isLogoPassed={isLogoPassed}
										/>
									</div>

									{filterLoader || (errorCode && errorCode.length > 0) ? (
										filterLoader ? (
											<ProductLoader
												disableMsg={disableRandomMsg}
												ecomSearchVertical={ecomSearchVertical}
											/>
										) : (
											errorCode &&
											errorCode.length > 0 && (
												<div
													style={{
														display: 'grid',
														gridTemplateColumns: 'auto',
														paddingTop: '24px',
														width: 'calc(100%)',
														gap: '12px',
														height: '100vh',
														backgroundColor: '#faf8fc',
														justifyContent: 'center',
														marginTop: '10px',
													}}
												>
													<div
														style={{
															color: 'var(--black-60)',
															height: '100%',
															display: 'flex',
															alignItems: 'flex-start',
															justifyContent: 'center',
														}}
														className='ff-chatbot-body1'
													>
														"We are currently facing an issue (Error Code:{' '}
														{errorCode}). Please try again later."
													</div>
												</div>
											)
										)
									) : (
										<EcomChats
											ecomSearchVertical={ecomSearchVertical}
											topProductID={topProductID}
											onClose={() => {
												setShowCart(false);
											}}
											storeStyle={storeStyle}
											messageId={msgId}
											handleSubmit={(data) => {
												setQueryText(data), submitChat();
											}}
											staticDetailsURL={staticDetailsURL}
											botId={botId}
											queryText={userMessage}
											styleAdvisorCache={styleAdvisorCache}
											styleAdvisor={styleAdvisor}
											handleStyleAdvisor={handleStyleAdvisor}
											getTitleMessage={getTitleMessage}
											message={
												showCart
													? title
														? 'Great you have selected ' + title
														: ''
													: message
											}
											metaData={metaData}
											token={token}
											tenantId={tenantId}
											time={time}
											showBack={showBack}
											showCartData={showCartData}
											showCart={showCart}
											reasonAPIPayload={reasonAPIPayload}
											secondAPI={
												metaData && metaData.get_products === 'true'
													? true
													: false
											}
											responseId={responseId}
											colorMode={colorMode}
											setSelectedProductData={(data) => {
												setSelectedProductData(data);
											}}
											conversationId={responseId}
											categoriesProductsArray={categoriesProductsArray}
											setTopProductsRowsCounter={setTopProductsRowsCounter}
											openThumbsPopup={openThumbsPopup}
											thumbFilledUp={
												chatMessages.length > 0 &&
												chatMessages
													.flat()
													.filter(
														(item) =>
															item.chatMessageDataServer.messageId === msgId
													)[0]?.chatMessageDataServer?.thumbFilledUp
											}
											popUpSnackBar={popUpSnackBar}
											enableStyleAdvisor={enableStyleAdvisor}
											enablePDP={enablePDP}
											advisorTitle={advisorTitle}
											nextPage={nextPage}
											enablePagination={true}
											handleSort={handleSort}
											product_count={product_count}
											totalProductCount={productCount}
										/>
									)}
								</div>
							) : null}
						</>
					)}
				</>
				{showChat &&
				(deviceType === 'mobile' || deviceType === 'tablet') &&
				!showCart ? (
					<>
						{metaData && metaData.products && metaData.products.length ? (
							<SortFilterContainer className='ff-sort-and-filter'>
								{filterModal ? (
									// <div className='ff-filter-modal' ref={filterModalRef}>
									// 	<EcomFilterMobile
									// 		filterData={filterData}
									// 		queryText={userMessage}
									// 		id={responseId}
									// 		msgId={msgId}
									// 		handleFilter={handleFilter}
									// 		currency={currencyCode}
									// 		productCount={productCount}
									// 		uploadedImage={uploadedImage.length > 0 ? true : false}
									// 		onClose={() => { setFilterModal(false) }}
									// 	/>
									// </div>
									<div
										className='ff-filter-modal'
										style={{
											height: '100vh',
											backgroundColor: 'var(--black-40)',
										}}
									>
										<div className='ff-filter-modal' ref={filterModalRef}>
											<div className='title'>
												<div className='ff-chatbot-caption'>Filters</div>
												{selectedOptions.length || filterSelected ? (
													<div
														className='ff-chatbot-caption'
														style={{ cursor: 'pointer' }}
														onClick={() => {
															setFilterModal(false), setSelectedOptions([]);
															setFilterSelected(false);
															setPrevPriceRange(null);
															setPriceRange([priceMin, priceMax]);
															setPrevFilter([]);
															if (prevFilter.length || prevPriceRange) {
																handleFilter({});
															}
														}}
													>
														CLEAR ALL
													</div>
												) : null}
											</div>
											<div className='ff-filter-content'>
												<div className='filters'>
													{filters.map((v, index) => {
														const priceKeyValue = v.price
															? 'price'
															: v.sale_price
															? 'sale_price'
															: '';

														// setPrevPriceRange([
														// 	v.price ? v.price.min : v.sale_price.min,
														// 	v.price ? v.price.max : v.sale_price.max,
														// ])

														return (
															<>
																<div
																	key={index}
																	className={`ff-chatbot-body1 data ${
																		activeIndex === index ? 'active' : ''
																	}`}
																>
																	<div
																		style={{ padding: '15px 10px' }}
																		onClick={() => {
																			setActiveIndex(index);
																			if (
																				priceKeyValue.toLowerCase() ===
																					'price' ||
																				priceKeyValue.toLowerCase() ===
																					'sale_price'
																			) {
																				setShowPrice(true);

																				setPriceKey(priceKeyValue);
																			} else {
																				let key = Object.keys(v).filter(
																					(item) => item !== 'filter_caption'
																				)[0];
																				setOptions(v[key]);

																				setShowPrice(false);
																			}
																		}}
																	>
																		{capitalizeFirstLetter(v.filter_caption)}
																	</div>
																</div>
															</>
														);
													})}
												</div>

												<div className='options'>
													{showPrice ? (
														<SliderContainer className='ff-slider-container'>
															<Slider
																onChangeCommitted={(event, newValue) => {
																	let updatedData;
																	updatedData = {
																		...selectedFilters,
																		[priceKey.toString()]: {
																			min: newValue[0],
																			max: newValue[1],
																		},
																	};
																	// }

																	setFilterSelected(true);
																	setSelectedFilters(updatedData);
																}}
																value={priceRange}
																onChange={(event, newValue) => {
																	// if (newValue[0] === newValue[1]) {
																	// 	newValue[1] += 200;
																	// }
																	setPriceRange(newValue as number[]);
																}}
																min={priceMin}
																max={priceMax}
															/>
															<div className='slider-labels'>
																<span>
																	{getCurrencySymbol(currencyCode)}
																	{NumberFormattinginLocale(priceRange[0])}
																</span>
																<span>
																	{getCurrencySymbol(currencyCode)}
																	{NumberFormattinginLocale(priceRange[1])}
																</span>
															</div>
														</SliderContainer>
													) : (
														<>
															{options &&
																options
																	.sort((a, b) =>
																		a.value.localeCompare(b.value)
																	)
																	.map((option, index) => {
																		const isSelected = selectedOptions.some(
																			(item) =>
																				item.key ===
																				`${activeIndex}-${option.value}`
																		);

																		return (
																			<div
																				key={index}
																				onClick={() => {
																					//setFilterSelected(true);
																					setProductCount(option.count),
																						handleOptionClick(
																							activeIndex,
																							option.value,
																							Object.keys(
																								filters[activeIndex]
																							).filter(
																								(item) =>
																									item !== 'filter_caption'
																							)[0]
																						);
																					// handleCheckboxChange(
																					// 	filters[activeIndex].filter_caption,
																					// 	option.value
																					// );
																				}}
																				style={{
																					display: 'flex',
																					alignItems: 'center',
																					padding: '15px 10px',
																					gap: '10px',
																					position: 'relative',
																					cursor: 'pointer',
																				}}
																			>
																				<>
																					<svg
																						xmlns='http://www.w3.org/2000/svg'
																						width='24'
																						height='24'
																						viewBox='0 0 24 24'
																						fill='none'
																					>
																						<g id='check'>
																							<path
																								id='Vector'
																								d='M8.79508 15.8749L4.62508 11.7049L3.20508 13.1149L8.79508 18.7049L20.7951 6.70492L19.3851 5.29492L8.79508 15.8749Z'
																								fill={
																									isSelected
																										? 'var(--secondary-color-ff-secondary500)'
																										: 'rgba(0,0,0,0.1)'
																								}
																							/>
																						</g>
																					</svg>
																					<div
																						style={{
																							color: 'rgba(0,0,0,0.6)',
																							fontWeight: isSelected
																								? 'bold'
																								: 'normal',
																						}}
																					>
																						{option.value}
																					</div>
																				</>
																				<div
																					style={{
																						color: '#94969f',
																						position: 'absolute',
																						right: '10px',
																						fontSize: '12px',
																						fontWeight: isSelected
																							? 'bold'
																							: 'normal',
																					}}
																				>
																					{/* {` (${option.count})`} */}
																				</div>
																			</div>
																		);
																	})}
														</>
													)}
												</div>
											</div>
											<div className='footer'>
												<div
													className='ff-chatbot-caption'
													onClick={() => {
														setFilterModal(false);
														prevFilter
															? setSelectedOptions(prevFilter)
															: setSelectedOptions([]);
														prevPriceRange
															? setPriceRange(prevPriceRange)
															: setPriceRange([priceMin, priceMax]);
														// setActiveIndex(0);
														// setShowPrice(false);
													}}
												>
													CLOSE
												</div>
												<div
													className='ff-chatbot-caption'
													onClick={() => {
														setFilterModal(false);
														handleCheckboxChange();
														//handleFilter(updatedFilter);
													}}
												>
													APPLY
												</div>
											</div>
										</div>
									</div>
								) : null}
								{sortModal ? (
									<div className='ff-sort-modal-container'>
										<div className='ff-sort-modal' ref={sortModalRef}>
											<div className='ff-chatbot-caption'>Sort by</div>
											{sortBy.map((v, index) => (
												<div
													key={index}
													onClick={() => {
														setActiveIndexSort(index);
														setSortModal(false);
														if (v !== 'Relevance') {
															handleSort({
																column: priceKey,
																order:
																	v.toLowerCase() === 'price: low to high'
																		? 'asc'
																		: 'desc',
															});
														} else {
															handleSort({});
														}
													}}
													className={`ff-chatbot-body1 data ${
														activeIndexSort === index ? 'active' : ''
													}`}
												>
													<div>{v}</div>
													{activeIndexSort === index && (
														<svg
															xmlns='http://www.w3.org/2000/svg'
															width='24'
															height='24'
															viewBox='0 0 24 24'
															fill='none'
														>
															<g id='check'>
																<path
																	id='Vector'
																	d='M8.79508 15.8749L4.62508 11.7049L3.20508 13.1149L8.79508 18.7049L20.7951 6.70492L19.3851 5.29492L8.79508 15.8749Z'
																	fill='var(--secondary-color-ff-secondary500)'
																/>
															</g>
														</svg>
													)}
												</div>
											))}
										</div>
									</div>
								) : null}
								<div className='ff-sort' onClick={() => setSortModal(true)}>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='25'
										height='24'
										viewBox='0 0 25 24'
										fill='none'
									>
										<g id='import_export'>
											<path
												id='Vector'
												d='M9.75 3L5.75 6.99H8.75V14H10.75V6.99H13.75L9.75 3ZM16.75 17.01V10H14.75V17.01H11.75L15.75 21L19.75 17.01H16.75Z'
												fill='var(--primary-color-ff-primary600)'
											/>
										</g>
									</svg>{' '}
									<div>Sort</div>
								</div>
								<div
									className='ff-filter'
									onClick={() => {
										setFilterModal(true);
									}}
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='25'
										height='24'
										viewBox='0 0 25 24'
										fill='none'
									>
										<g id='filter_alt'>
											<path
												id='Vector'
												d='M7.75506 6H17.7551L12.7451 12.3L7.75506 6ZM5.00506 5.61C7.02506 8.2 10.7551 13 10.7551 13V19C10.7551 19.55 11.2051 20 11.7551 20H13.7551C14.3051 20 14.7551 19.55 14.7551 19V13C14.7551 13 18.4751 8.2 20.4951 5.61C21.0051 4.95 20.5351 4 19.7051 4H5.79506C4.96506 4 4.49506 4.95 5.00506 5.61Z'
												fill='var(--primary-color-ff-primary600)'
											/>
										</g>
									</svg>
									<div>Filter</div>
								</div>
							</SortFilterContainer>
						) : null}
					</>
				) : null}
			</EcomContainer>
			{enableVoice && (
				<VoiceModal
					id={responseId}
					botId={botId}
					tenantId={tenantId}
					voiceText={(data) => {
						setQueryText(data);
						setUserMessage(data);
						setEnableVoice(false);
						if (enableIntent) {
							getIntent(data);
						} else {
							data.trimStart().length &&
								submitChat({ ...data, chatInput: data });
						}
					}}
				/>
			)}
			{enableUpload &&
				(screenSize < 500 || deviceType === 'tablet' ? (
					<UploadImageMobile
						setShowChat={setShowChat}
						setChatMessages={setChatMessages}
						setTime={setTime}
						setTopProductID={setTopProductID}
						setMetaData={setMetaData}
						setCategoriesProductsArray={setCategoriesProductsArray}
						setEnableUpload={setEnableUpload}
						setLoader={setLoader}
						msgId={msgId}
						responseId={responseId}
						token={token}
						previewImage={previewImage}
						setPreviewImage={setPreviewImage}
						setQueryText={setQueryText}
						setShowImageInInput={setShowImageInInput}
						setFilters={setFilters}
						setOptions={setOptions}
						setPagination={setPagination}
						setProductCount={setProductCount}
						setPaginatedCount={setPaginatedCount}
						clearFilter={() => {
							setMetaData('');
							setSelectedSortOption(sortOptions[0]);
							setDisableRandomMsg(false);
							setErrorCode('');
							setSelectedFilters({});
							setUploadedImage('');
							setShowExistingQueries(false);
							setFilterArray({});
							setSortFilter({});
							setPagination(1);
							setPrevFilter([]);
							setShowCart(false);
							setActiveIndex(0);
							setFilters([]);
							setOptions([]);
							setPrevPriceRange(null);
							setShowPrice(false);
							setActiveIndexSort(0);
						}}
					/>
				) : (
					<UploadImageDesktop
						messageId={msgId}
						botId={botId}
						conversationId={responseId}
						onClose={() => {
							setEnableUpload(false);
						}}
						tenantId={tenantId}
						clearFilter={() => {
							setMetaData('');
							setSelectedSortOption(sortOptions[0]);
							setDisableRandomMsg(false);
							setErrorCode('');
							setSelectedFilters({});
							setUploadedImage('');
							setShowExistingQueries(false);
							setFilterArray({});
							setSortFilter({});
							setPagination(1);
							setPrevFilter([]);
							setShowCart(false);
							setActiveIndex(0);
							setFilters([]);
							setOptions([]);
							setPrevPriceRange(null);
							setShowPrice(false);
							setActiveIndexSort(0);
						}}
						uploadImageResp={(resp) => {
							uploadImageResp(resp);
							setEnableUpload(false);
							setShowChat(true);
							setPagination(2);
						}}
					/>
				))}
			{isModalVisible && (
				<SFModal isModalVisible={true}>
					<MessageFeedbackComment
						msgKey={true}
						data={''}
						popUpSnackBar={popUpSnackBar}
						selectedRating={0}
						messageFeedbackCallback={() => {
							console.log('messageFeedbackCallback');
						}}
						messageFeedbackPrevVal={null}
						submitFeedback={submitFeedback}
						thumbFilledUp={thumbFilledUp}
						thumbFilledDown={null}
						messageId={msgId}
						colorMode={colorMode}
						openThumbsPopup={openThumbsPopup}
					/>
				</SFModal>
			)}
		</EcomSearcContainer>
	);
};

export default EcomSearch;
